import { useState, useEffect } from "react";

const CLICKBANK_HOP = "https://fbb3fpv745sq39ufzaqeh7ts3m.hop.clickbank.net/?&traffic_source=googleads&traffic_type=ppc&campaign=jointgen50plus-1&creative=landingpage&adgroup=articulacoes50plus-1&ad=review_1&extclid=googleleads";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/60"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <div className="flex items-center gap-6">
            <button
              onClick={() => scrollTo("#hero")}
              className="font-heading text-xl md:text-2xl font-semibold tracking-tight text-foreground-950 hover:text-primary-600 transition-colors"
            >
              JOINT GENESIS
            </button>
          </div>

          <nav className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollTo("#science")}
              className="text-base font-medium text-foreground-700 hover:text-primary-600 transition-colors"
            >
              The Science
            </button>
            <button
              onClick={() => scrollTo("#ingredients")}
              className="text-base font-medium text-foreground-700 hover:text-primary-600 transition-colors"
            >
              Ingredients
            </button>
            <button
              onClick={() => scrollTo("#faq")}
              className="text-base font-medium text-foreground-700 hover:text-primary-600 transition-colors"
            >
              FAQ
            </button>
          </nav>

          <div className="flex items-center gap-3">
            <a
              href={CLICKBANK_HOP}
              target="_blank"
              rel="noopener noreferrer"
              className="hidden md:inline-flex items-center px-5 py-3 rounded-full bg-primary-500 text-foreground-950 text-base font-bold hover:bg-primary-600 transition-colors whitespace-nowrap uppercase tracking-wide btn-hover-lift"
            >
              Check Availability
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}